<template>
    <div>
        <public-header title="大区管理"></public-header>
        <ak-model-filter-card model="region" @search="search" @reset="reset" />
        <div class="myCard">
            <ak-model-card model="region" ref="region" :page.sync="page" :filters="filters" tableSize="small"/>
        </div>
    </div>
  </template>
<script>

import publicHeader from '../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      filters: {
        parentNode: {
          $exists: true
        }
      },
      page: Number(this.$route.query.page) || 1
    }
  },
  watch: {
    page (val) {
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { page: this.page })
      })
    }
  },
  mounted () {
  },
  methods: {
    search (filters) {
      this.page = 1
      this.filters = {
        parentNode: {
          $exists: true
        }
      }
      this.filters = { ...this.filters, ...filters }
      console.log(this.filters)
    },
    reset () {
      this.page = 1
      this.filters = {
        parentNode: {
          $exists: true
        }
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
//   .myCard {
//     ::v-deep .ant-card-body{
//       padding: 0px 24px !important
//     }
//   }
  .myTab {
    padding: 24px 0 0 24px;
  }
  </style>
